import { APP_NAME, JobStatus, USER_ROLES } from '@teentack/shared';
import { Card, CardHeading } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';

/** Renders values imported from packages/shared — proves the wiring works. */
export function SharedPackageCard() {
  return (
    <Card as="section">
      <CardHeading>From @teentack/shared</CardHeading>

      <p className="mt-4 text-sm text-slate-600">
        <code className="rounded-md bg-slate-100 px-1.5 py-0.5 font-mono text-xs text-ink">
          APP_NAME
        </code>{' '}
        = {APP_NAME}
      </p>

      <p className="mt-5 text-xs font-bold tracking-[0.08em] text-slate-400 uppercase">
        USER_ROLES
      </p>
      <ul className="mt-2 flex flex-wrap gap-2">
        {USER_ROLES.map((role) => (
          <li key={role}>
            <Badge tone="brand">{role}</Badge>
          </li>
        ))}
      </ul>

      <p className="mt-5 text-xs font-bold tracking-[0.08em] text-slate-400 uppercase">JobStatus</p>
      <ul className="mt-2 flex flex-wrap gap-2">
        {Object.values(JobStatus).map((status) => (
          <li key={status}>
            <Badge tone="neutral">{status}</Badge>
          </li>
        ))}
      </ul>
    </Card>
  );
}
